module.exports = __webpack_public_path__ + "static/media/shanise_smile_pic.1427083f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pretty_Lashed/shanise_smile_pic.JPG
// module id = 469
// module chunks = 0